@let showComponent = showComponent$ | async;
@let fieldSettings = fieldsSettings$ | async;
@if (showComponent && fieldSettings) {
  <form [formGroup]="form">
    <ion-list lines="full" [inset]="true" class="no-last-line">
      <ion-list-header>Broker / Realtor Compensation</ion-list-header>
      @if (fieldSettings['salesCommissionBrokerCommissionTierRate'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            formControlName="salesCommissionBrokerCommissionTierRate"
            labelPlacement="stacked"
            placeholder="%"
            inputmode="decimal"
            type="text"
            [maskito]="rateMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">First $100K Commission</div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionTotal'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['salesCommissionBrokerCommissionTotal'].required === true"
            formControlName="salesCommissionBrokerCommissionTotal"
            labelPlacement="stacked"
            [placeholder]="(brokerCommissionTotalSettings$ | async)?.placeholder"
            [inputmode]="(brokerCommissionTotalSettings$ | async)?.inputMode ?? 'text'"
            type="text"
            [maskito]="(brokerCommissionTotalSettings$ | async)?.mask ?? null"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              {{ (brokerCommissionTotalSettings$ | async)?.label }}
              @if (fieldSettings['salesCommissionBrokerCommissionTotal'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      <ion-item-divider> Slide right all that apply: </ion-item-divider>

      @if (fieldSettings['salesCommissionBrokerCommissionSplits'].visible) {
        <ion-item>
          <ion-toggle formControlName="salesCommissionBrokerCommissionSplits">
            <span class="tw:text-xs tw:whitespace-normal">Show commission splits</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionTaxTotal'].visible) {
        <ion-item>
          <ion-toggle formControlName="salesCommissionBrokerCommissionTaxTotal">
            <span class="tw:text-xs tw:whitespace-normal">Include GET</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionTaxListing'].visible) {
        <ion-item>
          <ion-toggle formControlName="salesCommissionBrokerCommissionTaxListing">
            <span class="tw:text-xs tw:whitespace-normal">Include GET Listing Agent</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionTaxSelling'].visible) {
        <ion-item>
          <ion-toggle formControlName="salesCommissionBrokerCommissionTaxSelling">
            <span class="tw:text-xs tw:whitespace-normal">Include GET Buyer Agent</span>
          </ion-toggle>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionListing'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['salesCommissionBrokerCommissionListing'].required === true"
            formControlName="salesCommissionBrokerCommissionListing"
            labelPlacement="stacked"
            placeholder="$ / %"
            inputmode="decimal"
            type="text"
            [maskito]="rateAmountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              Listing Agent Commission
              @if (fieldSettings['salesCommissionBrokerCommissionListing'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }

      @if (fieldSettings['salesCommissionBrokerCommissionSelling'].visible) {
        <ion-item>
          <ion-input
            redErrorMessage
            [redRequired]="fieldSettings['salesCommissionBrokerCommissionSelling'].required === true"
            formControlName="salesCommissionBrokerCommissionSelling"
            labelPlacement="stacked"
            placeholder="$ / %"
            inputmode="decimal"
            type="text"
            [maskito]="rateAmountMask"
            [maskitoElement]="maskPredicate"
          >
            <div slot="label" class="tw:whitespace-normal">
              Buyer Agent Concession
              @if (fieldSettings['salesCommissionBrokerCommissionSelling'].required) {
                <ion-text color="danger">*</ion-text>
              }
            </div>
          </ion-input>
        </ion-item>
      }
    </ion-list>
  </form>
}
